(function () {
    'use strict';

    angular.module('app.notesReportSchedule', [
        'app.core',
        'app.widgets'
    ]);
})();
